import api from '~/services/api';

export async function obterAutenticidade(codigoValidacao) {
  return api.get(`/autenticidade/obter/${codigoValidacao}`);
}

export async function obterConfiguracoes() {
  return api.get('/autenticidade/configuracoes');
}
